/* eslint-disable space-before-blocks */
import Config from './Config.js'
import store from "@store"

class HTTPRequest{
  xhr = new XMLHttpRequest();

  // eslint-disable-next-line no-useless-constructor
  constructor () {
  }

  /**
   * Set the headers for the request
   */
  setupHeaders () {
    this.xhr.setRequestHeader('Content-Type', 'application/json')
    this.xhr.setRequestHeader('Access-Control-Allow-Origin', '*')
    this.xhr.setRequestHeader('Access-Control-Allow-Headers', '*')
  }

  /**
    *
    * @param {*} method - Method for the request
    * @param {*} url - URL for the request
    * @param {*} data - Data for the request (optional)
    */
  makeRequest (method, url, data) {
    var self = this
    url = Config.address + url

    if (!data) {
      data = null
    }

    if (data instanceof FormData) {
      // data.append('API_KEY', Config.api_key)
      // data.append('code', '11EA7CE699534625A13E0688F736643F')
      // data.append('user', 'kirepetrov')
    } else {
      data.API_KEY = store.getters.keys.api_key
      // data.code = '11EA86EC560B9A95A13E0688F736643F'
      // data.user = 'kirepetrov'
      data = JSON.stringify(data)
    }

    // Make asynchronous request
    return new Promise(function (resolve, reject) {
      self.xhr.open(method, url, true)

      // self.setupHeaders()

      self.xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(self.xhr.response)
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({
            status: this.status,
            statusText: self.xhr.statusText
          })
        }
      }

      self.xhr.onerror = function () {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({
          status: this.status,
          statusText: self.xhr.statusText
        })
      }

      self.xhr.send(data)
    })
  }

  makeRequestFormData (method, url, data) {
    var self = this
    console.log('Data', data)
    if (!data) {
      data = null
    }

    // Make asynchronous request
    return new Promise(function (resolve, reject) {
      self.xhr.open(method, url, true)

      // self.setupHeaders()

      self.xhr.onload = function (){
        if (this.status >= 200 && this.status < 300){
          resolve(self.xhr.response)
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({
            status: this.status,
            statusText: self.xhr.statusText
          })
        }
      }

      self.xhr.onerror = function (){
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({
          status: this.status,
          statusText: self.xhr.statusText
        })
      }

      self.xhr.send(data)
    })
  }
}

export default HTTPRequest
